import React from 'react';
import styles from './styles.module.scss';

const Topbar = () => {
  return (
    <div className={styles.contenedor}>
      <p><small>Envíos a todo el país</small></p>
      <span aria-hidden="true">📦</span>
    </div>
  );
};

export default Topbar;
